import { render, staticRenderFns } from "./DrillPenIconMath.vue?vue&type=template&id=d89e40ae&"
import script from "./DrillPenIconMath.vue?vue&type=script&lang=ts&"
export * from "./DrillPenIconMath.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports